var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-result',{attrs:{"status":"403","title":"403","sub-title":"Sorry, you don't have access to this page."},scopedSlots:_vm._u([{key:"extra",fn:function(){return [_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.toHome}},[_vm._v(" Back Home ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }